import { API_BASE_URL } from '../settings';
import axios from 'axios';

export const getTopicsByModuleIdAndCategoryAndLevel = (moduleId, category, level) => {
  return axios
    .get(API_BASE_URL + 'modules/' + moduleId + '/topics?category=' + category + '&level=' + level)
    .then(res => res.data)
    .then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/services/topic.services.js